angular.module('SpidApp')

.factory('UserSyncService',
        ['$http', 'SyncConfig', 'Chunker', '$q',
function ($http,   SyncConfig,   Chunker,   $q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/synchro/users')
  var nodePushUrl = SyncConfig.Node.getURLFor('/synchro/users')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/users')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var UserSyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'UserSyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (users) {
          return _.filter(users, function (user) {
            return moment(user.updated_at).isAfter(moment(lastSyncIsoDate), 'second')
          })
        })
      },

      pushAll: function (elems) {
        var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
        var p = $q(function (r) {r()})
        
        var pools = []
        for(var i = 0 ; i < chunked.length ; i++) {
          var data = chunked[i]
          var req = { method: 'POST', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
          pools.push($http(req))
        }
        
        return p.then(function () {
          return $q.all(pools)
        }).then(function () {
          return {users: 'OK'}
        })
      }
    },
    Distant: {
      getAllUnsync: function () {
        var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }

        return $http(req).then(function (response) {
          return response.data
        })
      },

      pushAll: function (users) {
          var chunked = Chunker.inConstantSizeChunks(users, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      }
    }
  }

  return UserSyncService
}])